import { useEffect } from "react";
import { useParams } from "react-router-dom";
import MenuNotFound from "@/components/MenuNotFound";
import LoadingWaves from "@/components/LoadingWaves";
import { setFavicon } from "@/helpers/favicon";
import { setAnalytics } from "@/helpers/analytics";
import { useBranchMenu } from "@/hooks/useBranchMenu";
import { resolveTheme } from "@/themes";

// Dispatcher: ortak veri + kesişen efektler (title/favicon/GA) + yükleme/hata durumları
// burada; görsel sunum branch.settings.theme'e göre seçilen tema bileşeninde. Temalar
// aynı props sözleşmesini (data, branches, branchSlug) paylaşır.
const MainMenu = () => {
  const { branchSlug } = useParams();
  const { data, branches, fetching, failKind } = useBranchMenu(branchSlug);

  const tenant = data?.tenant;
  const branch = data?.branch;

  useEffect(() => {
    if (tenant?.name && branch?.name) {
      document.title = `${tenant.name} - ${branch.name}`;
    }
    setFavicon({
      ...tenant?.icons,
      markUrl: tenant?.markUrl,
      logoUrl: tenant?.logoUrl,
    });
  }, [
    tenant?.name,
    tenant?.logoUrl,
    tenant?.markUrl,
    tenant?.icons,
    branch?.name,
  ]);

  // branch.slug === branchSlug şartı: şube değişiminde data bir tur eski şubede kalıyor, o
  // aralıkta atılan görüntüleme yanlış property'ye yazılırdı.
  useEffect(() => {
    if (branch?.slug === branchSlug) {
      setAnalytics(branch.settings?.gaMeasurementId);
    }
  }, [branchSlug, branch?.slug, branch?.settings?.gaMeasurementId]);

  if (fetching) {
    return <LoadingWaves />;
  }

  if (failKind === "notFound") {
    return <MenuNotFound title="Menü Bulunamadı" />;
  }

  if (failKind) {
    return (
      <MenuNotFound title="Bağlantı Hatası" message="Lütfen tekrar deneyin." />
    );
  }

  // Şekil bozuk payload'ı "Menü yakında" gibi göstermek gerçek hatayı gizler.
  if (!Array.isArray(data?.categories)) {
    console.error("[menu] malformed menu payload", data);
    return <MenuNotFound title="Menü Bulunamadı" />;
  }

  if (!data.categories.length) {
    return (
      <MenuNotFound
        title="Menü yakında"
        message="Bu şubenin menüsü henüz hazırlanıyor."
      />
    );
  }

  const Theme = resolveTheme(branch?.settings?.theme);

  // key={branchSlug}: şube değişince tema state'i (seçili kategori vs.) sıfırlanır.
  return (
    <Theme
      key={branchSlug}
      data={data}
      branches={branches}
      branchSlug={branchSlug}
    />
  );
};

export default MainMenu;
